<script setup lang="ts">
	import { nextTick, ref, watch } from "vue";
	import SeanIcon from "@/components/icons/SeanIcon.vue";

	const props = defineProps<{
		modelValue: boolean;
		reviewedCount: number;
		total: number;
	}>();

	const emit = defineEmits<{
		"update:modelValue": [value: boolean];
		goBack: [];
		continue: [];
	}>();

	const continueClicked = ref(false);

	watch(
		() => props.modelValue,
		(value) => {
			if (value) continueClicked.value = false;
		}
	);

	const handleContinue = () => {
		if (continueClicked.value) return;
		continueClicked.value = true;
		emit("continue");
		void nextTick(() => {
			if (props.modelValue) {
				continueClicked.value = false;
			}
		});
	};
</script>

<template>
	<v-dialog :model-value="modelValue" max-width="560" persistent @update:model-value="emit('update:modelValue', $event)">
		<v-card class="review-complete-card" rounded="xl" elevation="8">
			<div class="d-flex justify-end">
				<v-btn icon variant="text" size="small" @click="emit('goBack')">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</div>

			<div class="d-flex ga-5 align-start confirm-layout">
				<SeanIcon :enable-tooltip="false" :height="72" :width="72" class="flex-shrink-0 mt-1" />
				<h5 class="review-complete-title">
					Spark Guide review is complete. You reviewed {{ reviewedCount }} of {{ total }} files. If you are satisfied with all
					{{ total }} guides, press Continue.
				</h5>
			</div>

			<div class="d-flex ga-4 mt-7 actions">
				<v-btn class="review-complete-action flex-grow-1" variant="outlined" rounded="xl" @click="emit('goBack')">Go Back</v-btn>
				<PrimaryBtn
					class="review-complete-action flex-grow-1"
					:loading="continueClicked"
					:disabled="continueClicked"
					@click="handleContinue">
					Continue
				</PrimaryBtn>
			</div>
		</v-card>
	</v-dialog>
</template>

<style scoped lang="scss">
	.review-complete-card {
		padding: 1.25rem 1.75rem 1.75rem;
		border-radius: 16px !important;
	}

	.review-complete-title {
		margin: 0;
		color: rgb(var(--v-theme-on-surface));
		font-size: 1.375rem;
		font-weight: 600;
		line-height: 1.28;
		letter-spacing: 0;
	}

	.review-complete-action {
		min-height: 48px;
		font-size: 0.95rem;
		font-weight: 600;
		letter-spacing: 0;
	}

	@media #{map.get($display-breakpoints, 'xs')} {
		.review-complete-card {
			padding: 1rem;
		}

		.confirm-layout,
		.actions {
			flex-direction: column;
		}

		.review-complete-title {
			font-size: 1.125rem;
		}
	}
</style>
